<div class="row">
  <div class="col d-flex">
    <div class="everlabel">
      <span>Modality *</span>
    </div>
    <div class="ml-3 everlabel">
      <span>Study Description *</span>
    </div>
    <div class="ml-3 everlabel">
      <span>Image Count *</span>
    </div>
    <div class="ml-3 everlabel">
      <span>Accession Number</span>
    </div>
  </div>
</div>
<div class="row">
  <div class="col">
    <app-study-row
      *ngFor="let studyForm of studyForms.controls; let rowIndex = index"
      [studyForm]="studyForm"
      [rowIndex]="rowIndex"
      [commonStudies]="commonStudies"
      [modalityList]="modalityList"
      [studiesGroups]="studiesGroups"
      (studyChange)="onStudyChange($event)"
    >
      <div class="ml-3">
        <button
          type="button"
          *ngIf="studyForms.length > 1"
          (click)="deleteStudy(rowIndex)"
          id="deleteStudy"
          mat-icon-button
        >
          <mat-icon class="mat-evericon">delete_outline</mat-icon>
        </button>
        <button
          type="button"
          *ngIf="rowIndex === studyForms.length - 1"
          (click)="addStudy()"
          id="addStudy"
          class="ml-2"
          mat-icon-button
        >
          <mat-icon class="mat-evericon">add</mat-icon>
        </button>
      </div>
    </app-study-row>
  </div>
</div>
